import { createSelector } from 'reselect';
import applicationModeSelector from './applicationMode';
import { PAGE_TEMPLATES } from '../const';

export default createSelector(
  applicationModeSelector,
  applicationMode => applicationMode === PAGE_TEMPLATES
);
